import { render, staticRenderFns } from "./add-custom.vue?vue&type=template&id=6833195c&scoped=true&"
import script from "./add-custom.vue?vue&type=script&lang=ts&"
export * from "./add-custom.vue?vue&type=script&lang=ts&"
import style0 from "./add-custom.vue?vue&type=style&index=0&id=6833195c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6833195c",
  null
  
)

export default component.exports